import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import * as _ from 'lodash';

import { AdvancedLayout, Image, PlainGalleryConfig, PlainGalleryStrategy } from '@ks89/angular-modal-gallery';

import { environment } from '../../../../environments/environment';
import { DeleteDialogComponent } from '../edit-audit-item-dialog/deleted-dialog/delete-dialog.component';

@Component({
  selector: 'vr-edit-audit-picture-item-dialog',
  templateUrl: './edit-audit-picture-item-dialog.component.html',
  styleUrls: ['./edit-audit-picture-item-dialog.component.scss']
})
export class EditAuditPictureItemDialogComponent {

  data: any;
  actions: any = '';
  selectedIndex = 0;
  audit_actions = { audit_id: 0, actions: [], comment_auditor: '', deadline: '' };
  startDate = new Date(parseInt(moment().format('YYYY'), 10), parseInt(moment().format('MM'), 10) - 1, parseInt(moment().format('DD'), 10));

  file_upload;
  file_url = environment.SERVER_HOST + 'img/photos/';

  images: Image[] = [];
  customPlainGalleryRowConfig: PlainGalleryConfig = {
    strategy: PlainGalleryStrategy.CUSTOM,
    layout: new AdvancedLayout(-1, true)
  };

  @ViewChild('inputFile') inputFile: any;

  constructor(@Inject(MAT_DIALOG_DATA)
    public defaults: any,
    private i18n: I18n,
    private http: HttpClient,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private changeDetectorRefs: ChangeDetectorRef,
    private dialogRef: MatDialogRef<EditAuditPictureItemDialogComponent>,
  ) {
    this.data = _.cloneDeep(defaults);

    this.audit_actions.audit_id = this.data.audit_id;
    if (this.data.item.audit_actions[0]) {
      this.audit_actions.actions = this.data.item.audit_actions[0].actions;
      this.audit_actions.comment_auditor = this.data.item.audit_actions[0].comment_auditor;
      this.audit_actions.deadline = this.data.item.audit_actions[0].deadline;
    }

    if (this.data.item.photos) {
      this.data.item.photos.forEach((photo, index) => {
        this.images.push(
          new Image(
            index,
            {
              img: this.getImageUrl(photo.url_image)
            }
          )
        )
      }, this);
    } else {
      this.data.item.photos = [];
    }
  }

  async resizedataURL(datas, format) {
    return new Promise(async function(resolve, reject){

      // We create an image to receive the Data URI
      const img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function() {
        let wantedWidth;
        let wantedHeight;
        if (img.width > img.height) {
          wantedWidth = 1500;
          wantedHeight = img.height * 1500 / img.width;
        } else {
          wantedWidth = img.width * 1500 / img.height;
          wantedHeight = 1500;
        }

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        ctx.drawImage(img, 0, 0, wantedWidth, wantedHeight);

        const dataURI = canvas.toDataURL(format, 0.7);

        resolve(dataURI);
      };

      img.src = datas;
    })
  }

  upload() {
    const self = this;
    const reader = new FileReader();
    reader.readAsDataURL(this.inputFile.nativeElement.files[0]);
    reader.onload = async function () {
      const split = reader.result.split(';base64,');
      const newDataURI = await self.resizedataURL(reader.result, split[0].substring(5));
      self.http.post(environment.API_PATH + 'audit/photo', { audit_item_id: self.data.item.id, photo: newDataURI }, { withCredentials: true }).subscribe(response => {
        if (response['success']) {
          self.data.item.photos.push( response['photo']);
        }
      });
    };
    reader.onerror = function () {};
  }

  focusInput() {
    document.getElementById('file_input').click();
  }

  private isSafeImagePath(path: string): boolean {
    return /^[\w\-. ]+\.(jpg|jpeg|png|gif|webp)$/i.test(path);
  }

  getImage(image: string) {
    if (!this.isSafeImagePath(image)) { return ''; }
    // sonar:S6268 — isSafeImagePath interdit guillemets/parenthèses/slash, donc pas d'évasion possible hors du url('...') ni de path traversal
    return this.sanitizer.bypassSecurityTrustStyle(`url('${this.file_url + image}')`)
  }

  getImageUrl(image: string) {
    if (!this.isSafeImagePath(image)) { return ''; }
    // sonar:S6268 — nom de fichier validé par isSafeImagePath, concaténé à file_url (constante de build)
    return this.sanitizer.bypassSecurityTrustUrl(this.file_url + image)
  }

  openImageModalRow(image, index) {
    this.customPlainGalleryRowConfig = Object.assign({}, this.customPlainGalleryRowConfig, { layout: new AdvancedLayout(index, true) });
  }

  deleteImage(index) {
    this.dialog.open(DeleteDialogComponent, {} as MatDialogConfig).afterClosed().subscribe((data) => {
      if (data && data['delete']) {
        this.http.delete(environment.API_PATH + 'audit/photo/' + this.data.item.photos[index].id, { withCredentials: true }).subscribe(response => {
          if (response['success']) {
            this.data.item.photos.splice(index, 1);
            this.snackBar.open(this.i18n({ value: 'Photo deleted with success', id: 'PhotoDeletedWithSuccess' }), '', { duration: 5000 } as MatSnackBarConfig);
            this.changeDetectorRefs.detectChanges();
          } else {
            this.snackBar.open(this.i18n({ value: 'Something went wrong, please try again', id: 'SomethingWentWrongPleaseTryAgain' }), '', { duration: 5000 } as MatSnackBarConfig);
          }
        }, err => {
          this.snackBar.open(this.i18n({ value: 'Something went wrong, please try again', id: 'SomethingWentWrongPleaseTryAgain' }), '', { duration: 5000 } as MatSnackBarConfig);
        });
      }
    });
  }

  cancel() {
    this.dialogRef.close({ saved: false });
  }

  validate() {
    if (this.audit_actions.actions.length || this.audit_actions.deadline !== '') {
      if (this.audit_actions.deadline) {
        this.audit_actions.deadline = moment(this.audit_actions.deadline).format('YYYY-MM-DD');
      }
      this.data.item.audit_actions[0] = this.audit_actions;
    } else {
      this.data.item.audit_actions = [];
    }
    this.data.item.detail = this.data.item.observation.substr(0, 100);
    this.dialogRef.close({ ...this.data, saved: true });
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/edit-audit-picture-item-dialog/edit-audit-picture-item-dialog.component.ts